const electionMap = {
  en: { electionMap: { loadError: "Could not load some map boundaries" } },
  fr: { electionMap: { loadError: "Impossible de charger certaines limites de la carte" } },
};

export default electionMap;
